export default "__VITE_ASSET__BPETnImx__"